import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useLocations() {
    const [locations, setLocations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchLocations = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/locations`, { withCredentials: true });
            setLocations(Array.isArray(res.data) ? res.data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createLocation = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/locations`, payload, { withCredentials: true });
            await fetchLocations();
            return res.data?.location;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchLocations]);

    const updateLocation = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/locations/${id}`, payload, { withCredentials: true });
            await fetchLocations();
            return res.data?.location;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchLocations]);

    const deleteLocation = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/locations/${id}`, { withCredentials: true });
            await fetchLocations();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchLocations]);

    useEffect(() => {
        fetchLocations();
    }, [fetchLocations]);

    return {
        locations,
        loading,
        error,
        fetchLocations,
        createLocation,
        updateLocation,
        deleteLocation,
    };
}
